module.exports = __webpack_public_path__ + "blog-mobile.jpg?24a2c555a32dba282974d9517be10cc5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-mobile.jpg
// module id = 30
// module chunks = 0